import { DateTime } from 'luxon';
import { ICDV3ServiceItem } from './ServiceInterfaces';
import { eCDV3ItemTypes } from '../../enums/eCDV3ItemTypes';
import { ICDV3ViewItem } from '../interfaces/ICDViewItem';

export const transformFromViewItemToServiceItem = (item: Partial<ICDV3ViewItem>) => {
  const {
    buyer_at_closing,
    buyer_before_closing,
    created_at,
    paid_by_others,
    seller_at_closing,
    seller_before_closing,
    ...rest
  } = item;
  /*tslint:disable:object-literal-sort-keys*/
  const newItem = {
    ...rest,
    buyer_at_closing,
    buyer_before_closing,
    created_at: created_at || null,
    paid_by_others,
    seller_at_closing,
    seller_before_closing,
    netted_out: !!item.netted_out,
  } as ICDV3ServiceItem;
  /*tslint:enable:object-literal-sort-keys*/

  // FYI: custom transform based on type
  switch (item.type) {
    case eCDV3ItemTypes.percentage_of_loan_amount:
    case eCDV3ItemTypes.title_fee:
    case eCDV3ItemTypes.endorsement:
    case eCDV3ItemTypes.recording_fee:
    case eCDV3ItemTypes.tax:
      newItem.overridden = !!item.overridden;
      break;
    case eCDV3ItemTypes.non_interest_prepayment:
      newItem.months = item.months;
      break;
    case eCDV3ItemTypes.interest_prepayment: {
      const { amount_per_day, date_from, date_to } = item;
      newItem.amount_per_day = amount_per_day;
      if (!!date_from) {
        newItem.date_from = DateTime.fromJSDate(date_from).toUTC().toISO();
      }
      if (!!date_to) {
        newItem.date_to = DateTime.fromJSDate(date_to).toUTC().toISO();
      }
      break;
    }
    case eCDV3ItemTypes.prepayment_other:
      newItem.label = item.label || '';
      newItem.months = item.months;
      break;
    case eCDV3ItemTypes.escrow_at_closing:
      newItem.monthly_payment = item.monthly_payment;
      newItem.months = item.months;
      break;
    case eCDV3ItemTypes.escrow_at_closing_other:
      newItem.label = item.label || '';
      newItem.monthly_payment = item.monthly_payment;
      newItem.months = item.months;
      break;
    case eCDV3ItemTypes.recording_fee_other:
    case eCDV3ItemTypes.origination_fee_other:
    case eCDV3ItemTypes.endorsement_other:
    case eCDV3ItemTypes.tax_other:
    case eCDV3ItemTypes.other_fee:
    case eCDV3ItemTypes.title_fee_other:
    case eCDV3ItemTypes.other_loan_cost:
    case eCDV3ItemTypes.payoff:
      newItem.label = item.label || '';
      break;
    default:
      // NOT EXHAUSTIVE
      break;
  }

  return newItem;
};
